import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");
export default function Help() {
  const navigate = useNavigate();

  const handleTermsClick = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${API_ORIGIN}/admin-api/cms/content`,
        { slug: "terms-and-conditions" }
      );
      navigate("/about-us-detail", { state: { content: res.data } });
    } catch (error) {
      alert("Failed to load Terms and Conditions.");
    }
  };

  const handlePrivacyPolicyClick = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${API_ORIGIN}/admin-api/cms/content`,
        { slug: "privacy-policy" }
      );
      navigate("/about-us-detail", { state: { content: res.data } });
    } catch (error) {
      alert("Failed to load Privacy Policy.");
    }
  };

  return (
    <div className="help-page max-w-2xl mx-auto py-10">
      <h2 className="text-2xl font-bold mb-6">Help & Support</h2>
      <div className="space-y-4">
        <button
          className="underline text-blue-600 block"
          onClick={handleTermsClick}
        >
          Terms of Use
        </button>
        <button
          className="underline text-blue-600 block"
          onClick={handlePrivacyPolicyClick}
        >
          Privacy Policy
        </button>
      </div>
    </div>
  );
}